import React, { useEffect, useMemo, useState } from "react";
import "./Notes.css";
import { File } from "lucide-react";
import FileDrawer from "./FileDrawer.js";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import { Trash2, SquarePen, Search, Download, FileText, Sheet, FolderArchive } from "lucide-react";
import DateFinder from "../../utils/functions/DateFinder.js";
import { getNotes } from "../../redux/reduxApi/NotesReduxApi.js";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addNotes } from "../../redux/api/notesApi/NotesApi.js";
import { addNotesAction } from "../../redux/reduxSlice/NotesSlice.js";
import { deleteNotes } from "../../redux/api/notesApi/NotesApi.js";
import { deleteNotesAction } from "../../redux/reduxSlice/NotesSlice.js";
import { updateNotes } from "../../redux/api/notesApi/NotesApi.js";
import { updateNotesAction } from "../../redux/reduxSlice/NotesSlice.js";
import { X } from "lucide-react";
import { fileUpload } from "../../redux/api/surveyApi/SurveyApi.js";

function Notes(props) {
  const [isFileDrawerOpen, setIsFileDrawerOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [date, setDate] = useState("");
  const [notesData, setNotesData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const [selectedNote, setSelectedNote] = useState(null);
  const [data, setData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const getNotesData = useSelector((state) => state.notes.notes);
  const [files, setFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    attachments: [],
    moduleId: props.id,
    moduleName: props.module,
  });

  // Filter notes based on search term
  const filteredNotes = useMemo(() => {
    if (!searchTerm) return notesData;
    const term = searchTerm.toLowerCase();
    return notesData?.filter(({ notes }) =>
      notes?.title?.toLowerCase().includes(term) ||
      notes?.description?.toLowerCase().includes(term)
    );
  }, [notesData, searchTerm]);

  // for edit click
  const handleEditClick = (note) => {
    setFormData({
      title: note.title,
      description: note.description,
      attachments: note.attachments || [],
      moduleId: props.id,
      moduleName: props.module,
      ROWID: note.ROWID,
    });
    setSelectedNote(note);
    setIsOpen(true);
    setIsEditing(true);
  };

  const handleOnClose = () => {
    setFiles([]);
    closeDrawer();
  };

  // for updating
  const handleUpdate = (e) => {
    e.preventDefault();
    updateNotes(formData)
      .then((response) => {
        if (response.data.success) {
          dispatch(updateNotesAction(formData));
          toast.success("Note updated successfully!");
          closeDrawer();
          setIsEditing(false);
        } else {
          toast.error("Unable to update note. Please try again!");
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        toast.error("Failed to update note. Please try again.");
      });
  };

  // for Delete modal click
  const handleDeleteClick = (id) => {
    setNoteToDelete(id);
    setIsDeleteModalOpen(true);
  };

  // Delete function
  const handleDelete = (id) => {
    const data = { id };
    deleteNotes(data)
      .then((response) => {
        if (response.data.success) {
          dispatch(deleteNotesAction(data));
          toast.success("Note deleted successfully!");
          setIsDeleteModalOpen(false);
        } else {
          toast.error("Unable to delete note. Please try again!");
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        toast.error("Failed to delete note. Please try again.");
      });
  };

  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length + files.length > 5) {
      alert("You can upload a maximum of 5 files");
      return;
    }

    const uploadedFiles = await Promise.all(
      selectedFiles.map(async (file) => {
        const ImageData = {
          attachment: file,
          folderName: "attachmentsbucket",
        };

        const response = await fileUpload(ImageData);
        if (response.data.success) {
          return response.data.response[0][0];
        }
        return null;
      })
    );

    setFiles((prevFiles) => [...prevFiles, ...uploadedFiles.filter(file => file !== null)]);
  };

  // Submit Function
  const handleSubmit = async () => {
    try {
      const submissionData = new FormData();
      submissionData.append("title", formData.title);
      submissionData.append("description", formData.description);
      submissionData.append("moduleId", formData.moduleId);
      submissionData.append("moduleName", formData.moduleName);
      const addedBy = localStorage.getItem("userId");
      submissionData.append("userId", addedBy);
      submissionData.append("attachments", JSON.stringify(files));

      files.forEach((file) => {
        submissionData.append("files", file);
      });

      const response = await addNotes(submissionData);
      if (response?.data?.success) {
        dispatch(addNotesAction(formData));
        toast.success("Note added successfully!");
        const data = {
          id: reqId,
          page: 1,
        };
        dispatch(getNotes(data))
        closeDrawer();
      } else {
        toast.error("Failed to add note. Please try again!");
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      toast.error("Error uploading files. Please try again.");
    }
  };

  useEffect(() => {
    setNotesData(getNotesData);
  }, [getNotesData]);

  const reqId = useMemo(() => {
    return props.id;
  }, [props.id]);

  useEffect(() => {
    const page = 1;
    const data = {
      id: reqId,
      page: page,
    };
    dispatch(getNotes(data))
      .then((response) => { })
      .catch((error) => {
        console.log(error);
      });
  }, [reqId, dispatch]);

  useEffect(() => {
    if (notesData && notesData.length > 0) {
      setData(notesData);
    }
  }, [notesData]);

  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // open form
  const openDrawer = () => {
    setIsOpen(true);
  };
  const FileOpenDrawer = () => {
    setIsFileDrawerOpen(true);
  };
  const FileCloseDrawer = () => {
    setIsFileDrawerOpen(false);
  };

  // close form
  const closeDrawer = () => {
    setIsOpen(false);
    setFormData({
      title: "",
      description: "",
      attachments: [],
      moduleId: props.id,
    });
  };

  // for showing notes in modal
  const openDrawer1 = (note) => {
    setSelectedNote(note);
    setIsDrawerOpen(true);
  };

  // for closing notes in modal
  const closeDrawer1 = () => {
    setIsDrawerOpen(false);
    setSelectedNote(null);
  };

  const removeFileFromList = (idx) => {
    setFiles((prev) => prev.filter((file, index) => index !== idx));
  };

  return (
    <>
      {/* modal for delete */}
      <Modal isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={() => handleDelete(noteToDelete)}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal for viewing note details */}
      <Modal isOpen={isDrawerOpen} onClose={closeDrawer1}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Notes Title</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div>
              <p style={{ fontSize: "13px" }}>{selectedNote?.description}</p>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="d-flex w-100 justify-content-between ">
              <div className="d-flex gap-2 justify-content-start" style={{ bottom: 20, left: 15 }}>
                <FileText color="#ff176b" size="16px" strokeWidth="1" />
                <Sheet color="#ff176b" size="16px" strokeWidth="1" />
                <FolderArchive color="#ff176b" size="16px" strokeWidth="1" />
                <Trash2 color="#ff176b" size="16px" />
                <SquarePen color="#ff176b" size="16px" />
              </div>
              <button variant="outline" mr={3} onClick={closeDrawer1} className="cancel-button">
                Cancel
              </button>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Drawer for notes */}
      <Drawer size="lg" placement="right" onClose={handleOnClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{isEditing ? "Update Note" : "Create your notes"}</DrawerHeader>
          <DrawerBody>
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-12 mb-2">
                <div className="search-by-title">
                  <input className="rounded" type="text" style={{ outline: "none", border: "none" }} placeholder="Title" name="title" value={formData?.title} onChange={handleChange} />
                </div>
                <FormLabel className="small-label ps-3">Title</FormLabel>
              </div>
              <div className="col-lg-12 col-md-6 col-sm-12 mb-2">
                <textarea className="form-control rounded" rows="4" placeholder="Description" name="description" value={formData?.description} onChange={handleChange}></textarea>
                <FormLabel className="small-label ps-3 ms-2">Description</FormLabel>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-12 mb-2">
                <label
                  htmlFor="imageUpload"
                  className="image-upload position-relative"
                  style={{
                    border: "2px dashed lightgrey",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    overflow: "hidden",
                  }}
                >
                  <div className="w-50 mx-auto">
                    <input
                      onChange={handleFileChange}
                      className="form-control"
                      type="file"
                      id="imageUpload"
                      name="image"
                      multiple
                      style={{
                        opacity: 0,
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <p style={{ color: "grey", fontSize: "14px" }}>Drag and drop files here, or click to upload</p>
                </label>
                {files && files.length > 0 && (
                  <ul
                    className="file-list w-100"
                    style={{
                      marginTop: "10px",
                      padding: "5px 10px",
                      listStyle: "none",
                      fontSize: "14px",
                      maxHeight: "70px",
                      overflowY: "auto",
                      backgroundColor: "#f9f9f9",
                      border: "1px solid lightgrey",
                      borderRadius: "10px",
                    }}
                  >
                    {files.map((file, idx) => (
                      <li
                        className="d-flex align-items-center justify-content-between"
                        key={idx}
                        style={{
                          padding: "5px 0",
                          cursor: "pointer",
                          color: "#333",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={file.filename || file.name}
                      >
                        <span style={{ fontWeight: "bold", color: "#007bff" }}>
                          {idx + 1}. {file.filename || file.name}
                        </span>
                        <span>
                          <X
                            color="red"
                            size="16px"
                            strokeWidth="1"
                            onClick={() => {
                              removeFileFromList(idx);
                            }}
                          />
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
                <FormLabel className="small-label ps-3">Add Attachments</FormLabel>
              </div>
            </div>
          </DrawerBody>
          <center>
            <DrawerFooter style={{ display: "inline-block" }}>
              <div className="gap-3 d-flex">
                <button variant="outline" className="cancel-button" mr={3} onClick={handleOnClose}>
                  Cancel
                </button>
                <button onClick={isEditing ? handleUpdate : handleSubmit} className="create-button" style={{ backgroundColor: "#ff176b " }}>
                  {isEditing ? "Update" : "Submit"}
                </button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>

      {/* Top search bar section */}
      <div className="w-100 d-flex justify-content-between align-items-center my-4 pt-3 mobile-padding">
        <section>
          <div className="popup-search d-flex align-items-center bg-white">
            <Search size="18px" />
            <input
              type="search"
              className="ms-2 my-auto"
              style={{ outline: "none", border: "none", background: "none" }}
              placeholder="Search notes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </section>
        <section className="custom-scroll">
          <button onClick={openDrawer} className="save-button">
            Add note
          </button>
        </section>
      </div>

      {/* Notes card here */}
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <section>
          {filteredNotes?.length > 0 ? (
            filteredNotes.map(({ notes }, index) => (
              <div
                key={index}
                className="card-notes card"
                style={{
                  height: "auto",
                  borderRadius: "6px",
                  marginBottom: "10px",
                }}
              >
                <div className="card-body">
                  <div className="row position-relative">
                    <section>
                      <p className="mb-0">{notes?.title || "NA"}</p>
                      <p className="mb-2" style={{ color: "#afafaf" }}>
                        {notes?.description && notes?.description.length >= 80 ? notes?.description.slice(0, 80) + "..." : notes?.description}
                        {notes?.description && notes?.description.length >= 80 && (
                          <button
                            onClick={() => openDrawer1(notes)}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#ff176b",
                              cursor: "pointer",
                              paddingLeft: "5px"
                            }}
                          >
                            read more
                          </button>
                        )}
                      </p>
                      {notes?.attachments && notes.attachments.length > 0 && (
                        <div style={{ marginTop: "5px" }}>
                          {(() => {
                            let attachments = [];
                            try {
                              attachments = JSON.parse(notes.attachments);
                            } catch (error) {
                              console.error("Failed to parse attachments:", error);
                            }
                            return Array.isArray(attachments) && attachments.length > 0 ? (
                              <>
                                <h5 style={{ fontSize: "14px", fontWeight: "bold" }}>Attachments</h5>
                                <ul style={{ display: 'flex', flexDirection: 'wrap', gap: "10px", listStyle: "none", padding: 0 }}>
                                  {attachments.map((attachment, index) => (
                                    <li
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "5px 0",
                                      }}
                                    >
                                      <a href={attachment.filePath} target="_blank" rel="noopener noreferrer">
                                        <img
                                          src={attachment.filePath}
                                          alt={attachment.name}
                                          style={{ maxWidth: "100px", maxHeight: "100px", objectFit: "cover", borderRadius: "4px" }}
                                        />
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </>
                            ) : null;
                          })()}
                        </div>
                      )}
                      <span className="text-muted">{notes?.CREATEDTIME}</span>
                    </section>
                    <div className="d-flex gap-2 mt-2 ">
                      <span className="text-muted" style={{ fontSize: "13px", color: "#afafaf" }}>
                        {date.formattedDate} {date.formattedTime}
                      </span>
                    </div>
                  </div>
                  <section className="position-absolute" style={{ top: 15, right: 15 }}>
                    <div className="d-flex gap-2">
                      <Trash2
                        color="#ff176b"
                        size="18px"
                        onClick={() => handleDeleteClick(notes.ROWID)}
                        style={{ cursor: "pointer" }}
                      />
                      <SquarePen
                        color="#ff176b"
                        size="18px"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEditClick(notes)}
                      />
                    </div>
                  </section>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4">
              {searchTerm ? (
                <p>No notes found matching your search.</p>
              ) : (
                <p>No notes available. Create your first note!</p>
              )}
            </div>
          )}
        </section>
      </div>

      <FileDrawer closeDrawer={FileCloseDrawer} isFileDrawerOpen={isFileDrawerOpen} />
    </>
  );
}

export default Notes;